export default "__VITE_ASSET__B1mt7jUz__"